let singleton = Symbol();
let singletonEnforcer = Symbol();

class JSONLoader {

    constructor(enforcer) {
        if (enforcer !== singletonEnforcer) {
            throw 'Cannot construct ImageLoader singleton';
        }
    }

    static get instance() {
        if (!this[singleton]) {
            this[singleton] = new JSONLoader(singletonEnforcer);
        }

        return this[singleton];
    }

    static load(url = '') {
        return new Promise(function(resolve, reject) {

            let xhr = new XMLHttpRequest();

            xhr.open('GET', url);
            xhr.onreadystatechange = handler;
            xhr.responseType = 'json';
            xhr.setRequestHeader('Accept', 'application/json');
            xhr.send();

            function handler() {
                if (xhr.readyState === xhr.DONE) {
                    if (xhr.status === 200) {
                        let result = xhr.response;

                        // legacy browsers need json parse
                        if (typeof(result) == 'string') {
                            result = JSON.parse(xhr.response);
                        }
                        resolve(result);
                    } else {
                        reject(new Error(`load: ${url} falied with status: [${xhr.status}]`));
                    }
                }
            }
        });
    }

    static loadAll(urls) {
        return Promise.all(urls.map(url =>
            fetch(url).then(response => response.json())
        ));
    }

}

export default JSONLoader;
